import { format, parse, isValid } from 'date-fns';
import { WEEKDAYS_LONG, MONTHS, WEEKDAYS_SHORT, FIRST_DAY } from './locale.constants';
export const DATE_PICKER_TYPE = {
  SINGLE_SELECTION: 'singleSelection',
  RANGE_SELECTION: 'rangeSelection'
};
export const DEFAULT_DATE_FORMAT = 'dd/MM/yyyy';
export const getMaskString = function () {
  let dateFormat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_DATE_FORMAT;
  return dateFormat.replace(new RegExp(`[^${'./-'}]`, 'g'), '9');
};
export const getInputMaskOptions = function () {
  let dateFormat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_DATE_FORMAT;
  let placeholder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return {
    mask: getMaskString(dateFormat),
    alias: 'date',
    placeholder: placeholder ? placeholder : dateFormat,
    insertMode: false
  };
};
export const isRangeSelectionDatePicker = type => type === DATE_PICKER_TYPE.RANGE_SELECTION;
export const getDateObject = function (dateString) {
  let dateFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_DATE_FORMAT;
  if (dateString instanceof Date) return dateString;
  return parse(dateString, dateFormat, new Date());
};
export const getDateString = function (dateObject) {
  let dateFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_DATE_FORMAT;
  if (dateObject instanceof Date && !isNaN(dateObject)) {
    return format(dateObject, dateFormat);
  }
};
export const validateDateFormat = function (date) {
  let dateFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_DATE_FORMAT;
  const result = isValid(parse(getDateString(date, dateFormat), dateFormat, new Date())) || isValid(parse(date, dateFormat, new Date()));
  return result;
};
function formatDay(d) {
  let locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
  return `${WEEKDAYS_LONG[locale][d.getDay()]}, ${d.getDate()} ${MONTHS[locale][d.getMonth()]} ${d.getFullYear()}`;
}
function formatMonthTitle(d) {
  let locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
  return `${MONTHS[locale][d.getMonth()]} ${d.getFullYear()}`;
}
function formatWeekdayShort(i, locale) {
  return WEEKDAYS_SHORT[locale][i];
}
function formatWeekdayLong(i, locale) {
  return WEEKDAYS_SHORT[locale][i];
}
function getFirstDayOfWeek(locale) {
  return FIRST_DAY[locale];
}
export const localeUtils = {
  formatDay,
  formatMonthTitle,
  formatWeekdayShort,
  formatWeekdayLong,
  getFirstDayOfWeek
};